import { render, staticRenderFns } from "./CustomField.vue?vue&type=template&id=7312eb1c&scoped=true"
import script from "./CustomField.vue?vue&type=script&lang=js"
export * from "./CustomField.vue?vue&type=script&lang=js"
import style0 from "./CustomField.vue?vue&type=style&index=0&id=7312eb1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7312eb1c",
  null
  
)

export default component.exports